import { Injectable, inject } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class UrlTrackerService {
  private router = inject(Router);

  private prevUrl: string;

  get previousUrl(): string {
    return this.prevUrl;
  }

  constructor() {}

  trackPreviousUrl() {
    this.router.events.subscribe((e) => {
      if (e instanceof NavigationStart) {
        this.prevUrl = e.url;
      }
    });
  }
}
